/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface DurationBucket { 
    id?: string;
    name?: string;
    durationMs?: number;
    sampleCount?: number;
    missingCount?: number;
    combined?: boolean;
    source?: DurationBucket.SourceEnum;
}
export namespace DurationBucket {
    export type SourceEnum = 'MODULE_REPORTED' | 'STEP_CLOCK' | 'INSTANCE_CLOCK' | 'MIXED' | 'NONE';
    export const SourceEnum = {
        MODULEREPORTED: 'MODULE_REPORTED' as SourceEnum,
        STEPCLOCK: 'STEP_CLOCK' as SourceEnum,
        INSTANCECLOCK: 'INSTANCE_CLOCK' as SourceEnum,
        MIXED: 'MIXED' as SourceEnum,
        NONE: 'NONE' as SourceEnum
    };
}